export default {
  atoms: {
    adSlot: {
      adLabel: 'reklama'
    },
    authSupportCopy: {
      copy: 'Potřebujete další pomoc? Můžeme vám pomoci.',
      action: 'Napište nám'
    },
    premiumIdentifier: {
      iconText: 'Prémiový'
    },
    recaptchaCopy: {
      agreeLineOne: 'Tato stránka je chráněna prostřednictvím technologie reCAPCHA a dalších nástrojů Google.',
      agreeLineTwo: 'Ochrana soukromí',
      agreeLineThree: 'a',
      agreeLineFour: 'Podmínky používání služby',
      agreeLineFive: 'použít.',
      ariaLabel: {
        privacy: 'ochrana soukromí',
        terms: 'podmínky používání služby'
      }
    },
    termsAndConditions: {
      agreeLineOne: 'Registrací souhlasíte s',
      agreeLineTwo: 'podmínky',
      agreeLineThree: 'a',
      agreeLineFour: 'ochrana soukromí',
      agreeLineFive: 'Burda International CZ. Ze seznamu e-mailů se můžete kdykoli odhlásit.',
      ariaLabel: {
        privacy: 'ochrana soukromí',
        terms: 'obchodní podmínky'
      }
    },
    time: {
      formatTimeHours_one: '{{hours}} hod',
      formatTimeHours_few: '{{hours}} hod',
      formatTimeHours_many: '{{hours}} hod',
      formatTimeHours_other: '{{hours}} hod',
      formatTimeHours: '{{hours}} hod',
      formatTimeHours_plural: '{{hours}} hod',
      formatTimeHours_0: '{{hours}} hod',
      formatTimeHours_1: '{{hours}} hod',
      formatTimeHours_2: '{{hours}} hod',
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_few: '{{minutes}} min',
      formatTimeMins_many: '{{minutes}} min',
      formatTimeMins_other: '{{minutes}} min',
      formatTimeMins: '{{minutes}} min',
      formatTimeMins_plural: '{{minutes}} min',
      formatTimeMins_0: '{{minutes}} min',
      formatTimeMins_1: '{{minutes}} min',
      formatTimeMins_2: '{{minutes}} min'
    },
    instagramEmbed: {
      viewPostOnInstagram: 'Zobrazit více na Instagramu'
    }
  },
  molecules: {
    accountNav: {
      defaultLabel: 'Můj účet',
      registerText: 'Zaregistrovat',
      signInText: 'Přihlásit se',
      ariaLabel: {
        account: 'Účet'
      }
    },
    adBanner: {
      ariaLabel: {
        dismissText: 'Zavřít reklamní banner'
      }
    },
    ageVerificationModal: {
      title: 'Ověření věku',
      intro: 'Tato stránka obsahuje obsah určený pouze pro dospělé',
      deny: 'Je mi méně než  {{ageLimit}}',
      confirm: 'Je mi víc než  {{ageLimit}}',
      moreInfo: 'Více informací',
      remember: 'Zapamatuj si mě.'
    },
    authDropDown: {
      registerText: 'Zaregistrovat se',
      signInText: 'Přihlásit se'
    },
    batchedGrid: {
      showingItemsText: 'Zobrazují se položky 1 až {{nItemsShown}} z celkového počtu {{nItems}}',
      viewMoreButtonText: 'Prohlédnout více',
      showMoreButtonsText: 'Zobrazit více'
    },
    cookAndPrepTime: {
      sr: {
        timeRange: 'Příprava a čas vaření'
      },
      timeRange: {
        cook: 'Vaření',
        prep: 'Příprava',
        total: 'Celkový čas'
      }
    },
    eyebrowNav: {
      ariaLabel: {
        quickLinks: 'Rychlé odkazy'
      }
    },
    formAutoComplete: {
      ariaLabel: {
        noResult: 'Žádné výsledky',
        search: 'Hledat'
      }
    },
    formImageUpload: {
      button: {
        loadPrompt: 'Kliknutím přidáte fotografii',
        loadPromptRequired: 'povinné',
        loadPromptOptional: 'volitelné',
        ownImage: '*Prosím, potvrďte, že jde o vaši fotografii',
        remove: 'Odstranit',
        rotateLeft: 'Otočit doleva',
        rotateRight: 'Otočit doprava',
        save: 'Uložit'
      },
      error: {
        maxFileSize: 'Velikost souboru je příliš velká, nahrajte prosím obrázek menší než {(maxFileSize}}}MB',
        minHeight: 'Obrázek nesplňuje požadavek na minimální výšku {{minDimensions}}px',
        minWidth: 'Obrázek nesplňuje požadavek na minimální šířku {{minDimensions}}px'
      }
    },
    formMultiSelect: {
      ariaLabel: {
        formInput: 'Filtr {{label}}'
      },
      filterOptions: {
        noResult: 'Žádný výsledek',
        selectAllLabel: 'Vybrat všechno',
        inputPlaceholderSelect: 'Vybrat...',
        inputPlaceholderSelected: 'vybrané'
      },
      sr: {
        optionsButton: 'Přepnout zobrazení možností'
      }
    },
    formSortableInputs: {
      ariaLabel: {
        deleteInput: 'Smazat',
        grab: 'Uchop a přesuň'
      }
    },
    formSubmitButton: {
      button: {
        savedText: 'Uložené',
        savingText: 'Ukládání'
      }
    },
    gallery: {
      ariaLabel: {
        fullScreen: 'otevřít galerii na celou obrazovku'
      },
      imgCountText: '{{slideCount}} z {{images}}'
    },
    glossaryNav: {
      ariaLabel: {
        nav: 'slovníček'
      }
    },
    heightClamper: {
      button: {
        expandTextMore: 'Ukázat více',
        expandTextLess: 'Ukázat méně'
      }
    },
    ingredientsList: {
      heading: 'Suroviny'
    },
    inlineGallery: {
      imageCount: '{{imageCount}} z {{totalImages}}'
    },
    keyValueBlocks: {
      keyHeader: 'Klíč',
      prefixHeader: 'Zvýraznění',
      valueHeader: 'Hodnota'
    },
    lightBox: {
      ariaLabel: {
        close: 'zavřít'
      }
    },
    loadingIcon: {
      sr: {
        icon: 'Načítání'
      }
    },
    loadingState: {
      "default": {
        heading: 'One moment please...'
      },
      createAccount: {
        heading: 'Držte se pevně!',
        subHeading: 'Nastavujeme váš účet'
      },
      logout: {
        heading: 'One moment please...',
        subHeading: 'Just logging you out.'
      }
    },
    methodList: {
      methodLabel: 'Postup přípravy',
      counterPrefix: 'KROK'
    },
    modal: {
      ariaLabel: {
        close: 'Zavřít modal'
      }
    },
    numericPaginator: {
      icon: {
        prev: 'Předchozí',
        next: 'Další'
      },
      sr: {
        icon: 'Strana',
        nav: 'Právě jste na straně {{page}}'
      }
    },
    passwordCriteria: {
      ariaLabel: {
        notSatisfied: 'nesplňuje požadavky',
        satisfied: 'splňuje požadavky'
      },
      config: {
        bothCase: 'Malá a velká písmena',
        lowerCase: 'Malá písmena',
        minLength_one: 'Alespoň {{minLength}} znak',
        minLength_few: 'Alespoň {{minLength}} znaky',
        minLength_many: 'Alespoň {{minLength}} znaků',
        minLength_other: 'Alespoň {{minLength}} znaků',
        minLength: 'Alespoň {{minLength}} znak',
        minLength_plural: 'Alespoň {{minLength}} znaků',
        minLength_0: 'Alespoň {{minLength}} znak',
        minLength_1: 'Alespoň {{minLength}} znaky',
        minLength_2: 'Alespoň {{minLength}} znaků',
        requireDigit: 'Číslo (například 0-9)',
        symbol: 'Symbol (například !, ?, @)',
        upperCase: 'Velká písmena'
      },
      passwordContain: {
        text: 'Vaše heslo musí obsahovat'
      },
      sr: {
        passwordContain: 'Vaše heslo musí obsahovat:'
      }
    },
    passwordInput: {
      buttonText: {
        hide: 'SKRÝT',
        show: 'UKÁZAT'
      },
      formLabel: 'Heslo',
      placeholder: 'Vložte heslo',
      sr: {
        strength: 'Síla hesla je {{passwordStrength}}',
        visibility: {
          hidden: 'Skryté heslo',
          shown: 'Zobrazené heslo'
        }
      }
    },
    plantOverview: {
      averageYield: 'Průměrný výnos:',
      depth: 'Hloubka',
      size: 'Velikost rostliny:',
      spacing: 'Rozestupy:',
      spacingApart: '{{spacingApart}} od sebe',
      spacingBetween: '{{spacingBetweenRows}} mezi řádky'
    },
    popupToggleButton: {
      ariaLabel: {
        toggle: 'Přepnout popup {{popup}}'
      }
    },
    postContentStream: {
      ariaMessage: {
        itemsAdded: 'Nové položky přidané do',
        singleItemAdded: 'Nová položka přidaná do'
      }
    },
    postTeaser: {
      readMore: 'Číst více',
      publishDate: 'Publikováno: {{published}}'
    },
    rate: {
      sr: {
        legend: 'Kolik hvězdiček byste dali {{bestRating}}?',
        outOf: 'z',
        star_one: 'hviezdička',
        star_few: 'hviezdičky',
        star_many: 'hvězdiček',
        star_other: 'hvězdiček',
        star: 'hviezdička',
        star_plural: 'hvězdiček',
        star_0: 'hviezdička',
        star_1: 'hviezdičky',
        star_2: 'hvězdiček'
      }
    },
    rating: {
      ariaLabel: {
        rating: 'hodnocení'
      },
      countText: '{{count}} {{label}}',
      types: {
        // v4 plural
        rating_one: 'hodnocení',
        rating_few: 'hodnocení',
        rating_many: 'hodnocení',
        rating_other: 'hodnocení',
        // v3 plural
        rating: 'hodnocení',
        rating_plural: 'hodnocení',
        rating_0: 'hodnocení',
        rating_1: 'hodnocení',
        rating_2: 'hodnocení',
        // v4 plural
        review_one: 'recenze',
        review_few: 'recenze',
        review_many: 'recenze',
        review_other: 'recenze',
        // v3 plural
        review: 'recenze',
        review_plural: 'recenze',
        review_0: 'recenze',
        review_1: 'recenze',
        review_2: 'recenze'
      },
      inlineRateText: 'Hodnotit',
      skeletonRateText: 'Hodnotit'
    },
    ratingsCriteria: {
      overallLabel: 'Průměrné hodnocení'
    },
    searchForm: {
      ariaLabel: {
        performSearch: 'Hledej',
        resetButton: 'Resetovat vstup'
      }
    },
    sideBarNav: {
      ariaLabel: {
        settings: 'Moje nastavení',
        verticalNav: 'Strana'
      }
    },
    socialShare: {
      sr: {
        iconEmail: 'Poslam e-mailem příteli',
        iconShare: 'Sdílet na {{platform}}'
      }
    },
    socialSignInButton: {
      signUpWithButtonText: 'Zaregistrovat se přes',
      continueWithButtonText: 'Pokračovat s'
    },
    tableClamper: {
      collapseButtonText: 'Ukázat méně',
      expandButtonText: 'Ukázat více'
    },
    truncatedIcons: {
      tooltipLabel: 'víc'
    }
  },
  organisms: {
    emailSentConfirmation: {
      accountVerificationHeading: 'Poslali jsme ověřovací e-mail na adresu',
      passwordResetHeading: 'If you have an account, you\'ll receive an email to reset your password.',
      resendEmailCopy: 'Neobdrželi jste e-mail?',
      bodyCopy: 'Zkontrolujte prosím všechny složky v doručené poště, včetně spamu.',
      resendEmailButton: 'Kliknutím odešlete znovu',
      supportEmailSubject: 'Potřebuji pomoc s verifikací svého účtu. '
    },
    cardBuilder: {
      ariaLabel: {
        mediaImage: 'Zobrazit {{title}}'
      },
      offerCodeText: 'použít kód: {{offerCode}}'
    },
    cardCarouselSection: {
      errorMessage: 'Ups, při načítání dat se něco pokazilo. Zkuste prosím jinou možnost.',
      formLabel: 'Možnosti',
      infoMessage: 'Promiňte, žádná data nejsou k dispozici.',
      slidesToShowItems: 'Zobrazené položky {{currentSlide}} až {{nextSlides}} z celkového počtu {{allSlides}}',
      slidesToShowItem: 'Zobrazené položky {{currentSlide}} z {{allSlides}}'
    },
    carousel: {
      sr: {
        iconStack: '{{direction}} položka',
        paging: 'Strana {{pageNumber}}'
      }
    },
    resetPasswordForm: {
      headingCopy: 'Můj účet:',
      submitButton: 'Vložit heslo'
    },
    collection: {
      ariaLabel: {
        edit: 'Upravit',
        registerButton: 'Zaregistrovat se',
        share: 'Sdílet',
        signinButton: 'Přihlásit se'
      },
      author: '{{author}}',
      signinLinkText: 'Přihlásit se',
      signInLinkTitle: 'Přihlásit se',
      signInPromptLineOne: 'Je to vaše kolekce?',
      signInPromptLineTwo: 'editovat'
    },
    dynamicAccordian: {
      nextLabel_one: 'Ukázat další {{count}} položku',
      nextLabel_few: 'Ukázat další {{count}} položky',
      nextLabel_many: 'Ukázat dalších {{count}} položek',
      nextLabel_other: 'Ukázat dalších {{count}} položek',
      nextLabel: 'kázat další {{count}}  položku',
      nextLabel_plural: 'Ukázat dalších {{count}} položek',
      nextLabel_0: 'kázat další {{count}}  položku',
      nextLabel_1: 'Ukázat další {{count}} položky',
      nextLabel_2: 'Ukázat dalších {{count}} položek',
      previousLabel_one: 'Ukázat předcházející {{count}} položku',
      previousLabel_few: 'Ukázat předcházející {{count}} položky',
      previousLabel_many: 'Ukázat předcházejících {{count}} položek',
      previousLabel_other: 'Ukázat předcházející {{count}} položky',
      previousLabel: 'Ukázat předcházející {{count}} položku',
      previousLabel_plural: 'Ukázat předcházející {{count}} položky',
      previousLabel_0: 'Ukázat předcházející {{count}} položku',
      previousLabel_1: 'Ukázat předcházejících {{count}} položek',
      previousLabel_2: 'Ukázat předcházející {{count}} položky'
    },
    embeddedPost: {
      ariaLabel: {
        viewArticle: 'Zobrazit {{title}}'
      }
    },
    filters: {
      ariaLabel: {
        activeFilters: 'Aktivní filtry',
        closeFilters: 'Skrýt filtry',
        refine: 'Zpřesnit',
        showMoreFilters: 'Ukázat více filtrů',
        clearFiltersText: 'Zrušit filtry'
      },
      button: {
        clearFiltersText: 'Zrušit',
        refineText: 'Zpřesnit',
        showMoreFiltersText: 'Více filtrů',
        closeText: 'Zavřít'
      },
      clearAll: 'Vymazat vše',
      refineText: 'Zpřesnit vaše výsledky',
      yourFilters: 'Vaše filtry:',
      sr: {
        closeFilters: 'Zavřít panel filtrů'
      }
    },
    listPage: {
      showMoreButtonsText: 'Načíst další'
    },
    liveBlog: {
      errorMessage: 'Je nám líto, při načítání dalších položek se něco pokazilo, zkuste to prosím znovu.',
      isLiveUpdatedText: 'aktualizováno ŽIVĚ {{duration}}',
      liveIconTitle: 'živě',
      liveKickerTitle: 'Živě',
      loadMoreButtonText: 'Načíst další',
      notLiveUpdatedText: 'Aktualizováno {{duration}}',
      statusText: 'Přímý přenos této události je nyní ukončen',
      time: {
        lessThanOneHour_one: 'před {{count}} minutou',
        lessThanOneHour_few: 'před {{count}} minutami',
        lessThanOneHour_many: 'před {{count}} minutami',
        lessThanOneHour_other: 'před {{count}} minutami',
        lessThanOneHour: 'před {{count}} minutou',
        lessThanOneHour_plural: 'před {{count}} minutami',
        lessThanOneHour_0: 'před {{count}} minutou',
        lessThanOneHour_1: 'před {{count}} minutami',
        lessThanOneHour_2: 'před {{count}} minutami',
        lessThanOneMinute: 'před méně než minutou',
        moreThanHour_one: 'před {{count}} hodinou',
        moreThanHour_few: 'před {{count}} hodinami',
        moreThanHour_many: 'před {{count}} hodinami',
        moreThanHour_other: 'před {{count}} hodinami',
        moreThanHour: 'před {{count}} hodinou',
        moreThanHour_plural: 'před {{count}} hodinami',
        moreThanHour_0: 'před {{count}} hodinou',
        moreThanHour_1: 'před {{count}} hodinami',
        moreThanHour_2: 'před {{count}} hodinami'
      }
    },
    loginLanding: {
      button: {
        loginText: 'Prihláste se svou e-mailovou adresou '
      },
      link: {
        createAccountText: 'Vytvořit účet'
      },
      dividerText: 'nebo',
      newHereText: 'Jste zde poprvé?',
      loginHeaderText: 'Ahoj zase. Po vás se stýskalo, jsme rádi, že jste zpět'
    },
    loginForm: {
      emailLabel: 'e-mail ',
      emailPlaceholder: 'Zadejte svůj email',
      loginFormHeaderText: 'Zadejte své údaje pro přihlášení do svého účtu.',
      button: {
        loginText: 'Přihlásit se'
      },
      link: {
        forgotPasswordText: 'Zapomenuté heslo'
      }
    },
    mainNav: {
      ariaLabel: {
        main: 'Hlavní'
      },
      sr: {
        tierThreeBack: 'Zpět',
        tierTwoBack: 'Zpět'
      }
    },
    marketingPreferencesForm: {
      button: {
        saveMyPreferencesText: 'Uložit mé předvolby'
      },
      checkbox: {
        label: 'Ano, přihlaste mě'
      },
      heading: 'Chcete dostávat nabídky od {{brand}} a jejího vydavatele, společnosti Burda International CZ?',
      notification: {
        error: 'Vaše předvolby se nepodařilo uložit. Navštivte část Můj účet a aktualizujte svá nastavení.'
      }
    },
    newsLetterSignUp: {
      input: {
        emailPlaceholder: 'E-mailová adresa'
      }
    },
    post: {
      ariaLabel: {
        calloutButtonEdit: 'Upravit',
        calloutButtonPublish: 'Publikovat'
      },
      productSpec: {
        collapseButtonText: 'Méně podrobností',
        expandButtonText: 'Více podrobností',
        headline: 'Sprcifikace produktu',
        skip: 'Přeskočit na specifikaci produktu'
      },
      sr: {
        sponsoredHeading: 'Sponzorovaný obsah'
      }
    },
    postHeader: {
      button: {
        dealsText: 'Přeskočit na nabídky',
        print: 'Vytisknout'
      },
      itemCount: {
        items_one: 'položka',
        items_few: 'položky',
        items_many: 'položek',
        items_other: 'položek',
        items: 'položka',
        items_plural: 'položek',
        items_0: 'položka',
        items_1: 'položky',
        items_2: 'položek'
      },
      ourRatingText: 'Naše hodnocení',
      publishDate: 'Publikováno: {{published}}'
    },
    reaction: {
      ariaLabel: {
        "delete": 'Vymazat'
      },
      button: {
        replyText: 'Odpovědět',
        reportText: 'Zpráva'
      },
      removedText: 'Toto bylo odstraněno'
    },
    registrationForm: {
      createText: 'Vytvořit účet',
      emailPlaceholder: 'Vložte svůj e-mail',
      srButton: 'tlačítko.',
      emailLabel: 'E-mail'
    },
    registrationLanding: {
      ariaLabel: {
        signUpText: 'Klikněte sem pro přihlášení e-mailovou adresou'
      },
      button: {
        signUpText: 'Prihláste se svou e-mailovou adresou'
      },
      link: {
        loginText: 'Prihlásit se'
      },
      dividerText: 'Nebo',
      alreadyRegisteredText: 'Už jste registrováni?',
      registrationHeaderText: 'Vytvořte si svůj {{brand}} účet a dostávejte naše exkluzivní novinky e-mailem.'
    },
    forgottenPasswordForm: {
      formCopy: 'Vložte emailovou adresu, kterou jste použili při registraci a my vám pomůžeme s obnovou hesla. ',
      emailLabel: 'Email',
      emailPlaceholder: 'Vložte svůj email',
      resetPasswordButtonText: 'Obnovit heslo'
    },
    reviewSummary: {
      heading: 'Co jsme testovali'
    },
    roastCalculator: {
      button: {
        resetText: 'Obnovit'
      },
      imperialLabel: 'Imperiální',
      metricLabel: 'Metrický',
      sr: {
        imperialValueOunces: 'Imperiální hodnoty v uncích',
        imperialValuePounds: 'Imperiální hodnoty v librách',
        metricConverterLabel: 'Metrické hodnoty v {{converter}}',
        metricConverterUnit: '{{converter}} jednotka',
        selectMeat: 'Vyberte maso'
      },
      meat: {
        beefMedium: 'Hovězí (medium)',
        beefRare: 'Hovězí (rare)',
        beefWellDone: 'Hovězí (well done)',
        chicken: 'Kuře',
        duck: 'Kachna',
        goose: 'Husa',
        lambMedium: 'Jehněčí (medium)',
        lambRare: 'Jehněčí (rare)',
        lambWellDone: 'Jehněčí (well done)',
        pork: 'Vepřové',
        turkey: 'Krůtí',
        venisonMedium: 'Zvěřina (medium)',
        venisonRare: 'Zvěřina (rare)',
        venisonWellDone: 'Zvěřina (well done)'
      }
    },
    searchResults: {
      button: {
        loadPrevious: 'Načíst předchozí',
        loadNext: 'Načíst další'
      },
      showingItems: 'Zobrazujeme {{from}} až {{to}} z {{total}} výsledků.',
      noResults: 'Omlouváme se, došlo k chybě při načítání výsledků hledání, zkuste to znovu.'
    },
    siteFooter: {
      privacyItemLabel: 'Nastavení soukromí',
      privacyItemTitle: 'Spravujte své nastavení soukromí a souhlasů'
    },
    verificationError: {
      errorWithRetrySignUpCopy: 'Při pokusu o ověření vašeho účtu jsme narazili na problém. Zkuste se znovu zaregistrovat nebo kontaktujte podporu.',
      errorWithResendEmailCopy: 'Omlouvám se za to! Zkuste kliknutím níže odeslat nový ověřovací e-mail.',
      linkExpiredWithResendEmailCopy: 'Odkaz, který jsme vám poslali, již není platný, děláme to proto, aby byl váš účet zabezpečen. Kliknutím níže odešlete nový ověřovací e-mail.',
      supportEmailSubject: 'Potřebuji pomoc s ověřením účtu.'
    },
    weightVolumeConverter: {
      ariaLabel: {
        imperialValue: 'Imperialní hodnota v {{units}}',
        imperialValueOther: 'Imperialní hodnota v {{units}}',
        metricUnitText: 'výběr metrické jednotky',
        metricValueText: 'Metrická jednotka'
      },
      sr: {
        imperialValue: 'Imperialní hodnota v {{units}}',
        imperialValueOther: 'Imperialní hodnota v {{units}}',
        metricUnitText: 'Metrická jednotka',
        metricValueText: 'Metrická hodnota'
      },
      volumeText: 'Objem',
      weightText: 'Váha'
    }
  },
  templates: {
    searchPage: {
      title: 'Výsledky vašeho hledání.',
      noResults: 'Omlouváme se, ale nepodařilo se najít žádné výsledky. Zkuste aktualizovat váš vyhledávací termín.',
      error: 'Omlouváme se, došlo k problému při načítání výsledků hledání.',
      sort: 'Seřadit'
    }
  }
};